class AgreementsListController {
    public currentPage: number;
    public itemsPerPage: number;

    constructor() {
        'ngInject';
    }

    public $onInit = () => {
        this.currentPage = 1;
        this.itemsPerPage = 12;
    }

    public $onChanges = () => {
    
    }
    
    parseDate(item) {
        var date = new Date(item.start);
        return date;
    }
}

export const agreementsListComponent = {
    bindings: {
        agreements: "<"
    },
    controller: AgreementsListController,
    template: require('./agreements.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/agreements/agreements.list.component.ts